import css from "./SelectMeasurement.module.css";

function SelectedMeasurement(props) {
  return (
    <div>
      {props.ingredientRow ? (
        <label>
          Select measurement type:
          <select
            className={css.select}
            name="Select measurement type"
            defaultValue="both"
            onChange={(state) =>
              props.setSelectedMeasurement(state.target.value)
            }
          >
            <option value={"metric"}>Metric</option>
            <option value={"imperial"}>Imperial</option>
            <option value={"both"}>Both</option>
          </select>
        </label>
      ) : null}
    </div>
  );
}

export default SelectedMeasurement;
